import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { FetchResult } from '@apollo/client'
import { ConfigurableProductItem, CustomizableOption } from 'lib/core/data/quote/addProduct/types'
import { ServiceDependencies } from 'lib/core/services/magento'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface AddConfigurableProductToCartMutationObject {
  mutation: {
    addConfigurableProductsToCart: {
      __args: {
        input: {
          cart_id: string
          cart_items: Record<string, any>
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const addConfigurableProductToCartMutationObject: AddConfigurableProductToCartMutationObject = {
  mutation: {
    addConfigurableProductsToCart: {
      __args: {
        input: {
          cart_id: '',
          cart_items: []
        }
      }
    }
  }
}

interface AddConfigurableProductMutationInput {
  cartId: string
  cartItems: ConfigurableProductItem[] // TODO: unify interface/types with src/data/quote/addProduct/index.ts
}

export type AddConfigurableProductToCartMutation = (input: AddConfigurableProductMutationInput) => Promise<FetchResult<any>>

interface ProductItem {
  parent_sku: string
  data: {
    quantity: number
    sku: string
    [key: string]: any
  }
  customizable_options?: CustomizableOption[]
}

export const createAddConfigurableProductToCartMutation = ({ getMutations, getQueries }: ServiceDependencies): AddConfigurableProductToCartMutation => async (input) => {
  const queries = getQueries()
  const { cartId, cartItems } = input
  const items = cartItems.map(item => {
    const {
      configurableSku,
      quantity,
      sku,
      additionalAttrs,
      customizableOptions,
      ...rest
    } = item

    const additionalAttrMapped: Record<string, any> = {}
    additionalAttrs?.forEach(additionalAttr => {
      additionalAttrMapped[additionalAttr.key] = additionalAttr.value
    })

    const finalObject: ProductItem = {
      parent_sku: configurableSku,
      data: {
        ...rest,
        quantity,
        sku,
        ...additionalAttrMapped
      }
    }

    if (customizableOptions?.length) {
      finalObject.customizable_options = customizableOptions.map(({ id, value_string: valueString }) => ({
        id,
        value_string: valueString
      }))
    }

    return finalObject
  })

  const mutation = getMutations().addConfigurableProductToCartMutation
  mutation.mutation.addConfigurableProductsToCart.__args.input.cart_id = cartId
  mutation.mutation.addConfigurableProductsToCart.__args.input.cart_items = items
  mutation.mutation.addConfigurableProductsToCart = {
    ...mutation.mutation.addConfigurableProductsToCart,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses,
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
